export default __webpack_public_path__ + "static/media/burger-bread-top.17053f1d.svg";